import { endpoints } from '../../../config';
import appClient from '../../common/services/AppClient';
import {
    SearchAdministrationHistoryFilter,
    SearchAdministrationHistoryResult,
    SearchHistoryFilter,
    SearchHistoryResult
} from './types';

export default class HistoryService {
    async searchHistory(filter: SearchHistoryFilter) {
        const url = `${endpoints.manageUrl}history/search`;
        const result = await appClient.post<SearchHistoryResult['searchHistory']>(url, filter);
        const response = result.unwrapOr({ historyRecords: [], total: 0 });

        return {
            historyRecords: response.historyRecords,
            total: response.total
        };
    }

    async getProjectImportDetails(projectId: string, operationId: string, page: number, pageSize: number) {
        const url = `${endpoints.manageUrl}history/project/${encodeURIComponent(projectId)}/imports/${encodeURIComponent(
            operationId
        )}/details?page=${page}&pageSize=${pageSize}`;
        return appClient.get<SearchHistoryResult['searchHistory']>(url);
    }

    async searchAdministrationHistory(filter: SearchAdministrationHistoryFilter) {
        const url = `${endpoints.manageUrl}history/administration/search`;
        const result = await appClient.post<SearchAdministrationHistoryResult['searchAdministrationHistory']>(
            url,
            filter
        );
        const response = result.unwrapOr({ historyRecords: [], total: 0 });

        return {
            historyRecords: response.historyRecords,
            total: response.total
        };
    }
}
